import { useState, useCallback } from 'react';
import { fetchPincodeDetails } from '../utils/pincodeApi';

/**
 * Hook to fetch address details when user enters a 6-digit pincode.
 * Returns state, district, address suggestions, loading and error state.
 */
export const usePincodeLookup = () => {
  const [pincodeData, setPincodeData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const lookupPincode = useCallback(async (pincode) => {
    const pin = String(pincode || '').trim();
    if (pin.length !== 6) {
      setPincodeData(null);
      setError(null);
      return null;
    }

    setLoading(true);
    setError(null);
    try {
      const data = await fetchPincodeDetails(pin);
      setPincodeData(data);
      if (!data) {
        setError('Invalid pincode or no data found');
      }
      return data;
    } catch (err) {
      setError('Failed to fetch pincode details');
      setPincodeData(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setPincodeData(null);
    setLoading(false);
    setError(null);
  }, []);

  return {
    pincodeData,
    loading,
    error,
    lookupPincode,
    reset,
  };
};
